define("media/components/media/bulk-label-item", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="cLB--filter__item">
    <div class="cLB--label u--ellipsis {{if this.isSelected 'is--active'}}" {{on "click" (fn @updateLabel @label)}}>
      {{#if this.isSelected}}
        {{svg-jar "check" class="o--icon o--icon--success"}}
      {{/if}}
      <span>
        {{@label.canonicalTagName}}
      </span>
  
      <span class="cLB--label__counter">
        {{@label.taggedCount}}
      </span>
    </div>
  </div>
  */
  {
    "id": "Ae+/MRDY",
    "block": "[[[10,0],[14,0,\"cLB--filter__item\"],[12],[1,\"\\n  \"],[11,0],[16,0,[29,[\"cLB--label u--ellipsis \",[52,[30,0,[\"isSelected\"]],\"is--active\"]]]],[4,[38,1],[\"click\",[28,[37,2],[[30,1],[30,2]],null]],null],[12],[1,\"\\n\"],[41,[30,0,[\"isSelected\"]],[[[1,\"      \"],[1,[28,[35,3],[\"check\"],[[\"class\"],[\"o--icon o--icon--success\"]]]],[1,\"\\n\"]],[]],null],[1,\"    \"],[10,1],[12],[1,\"\\n      \"],[1,[30,2,[\"canonicalTagName\"]]],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,1],[14,0,\"cLB--label__counter\"],[12],[1,\"\\n      \"],[1,[30,2,[\"taggedCount\"]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@updateLabel\",\"@label\"],false,[\"if\",\"on\",\"fn\",\"svg-jar\"]]",
    "moduleName": "media/components/media/bulk-label-item.hbs",
    "isStrictMode": false
  });
  class BulkLabelItemComponent extends _component2.default {
    get isSelected() {
      return this.args.selectedLabels.includes(this.args.label);
    }
  }
  _exports.default = BulkLabelItemComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BulkLabelItemComponent);
});